import UserService from 'Services/user';

export default {
	name: 'ForgotPasswordModal',
	created() {
		this.email = this.$route.query.email || '';
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			isLoading: false,
			isEmailSent: false,
			email: ''
		};
	},
	methods: {
		requestResetPassword() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.isLoading = true;
					UserService.requestResetPassword(this.email)
						.then(response => {
							// Redirect to login!
							this.isEmailSent = true;
						})
						.catch(() => {
							this.errors.add({
								field: 'apierror',
								msg: error.response.data.Message
							});
						})
						.finally(() => {
							this.isLoading = false;
						});
				}
			});
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/forgot-password-modal/script.js